import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbfe8692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "downloaded" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "file-name" }, [
  /*#__PURE__*/_createTextVNode("json_file_extension.xls " + /*#__PURE__*/_toDisplayString(' ')),
  /*#__PURE__*/_createElementVNode("span", { class: "file-size" }, "350 KB")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      class: "icon-file",
      name: "ic20-file",
      color: "--sui-purple-500"
    }),
    _hoisted_2,
    _createVNode(_component_Icon, {
      class: "icon-delete",
      spriteUrl: "/image/videoconf-icons.svg",
      name: "ic20-delete-gray"
    })
  ]))
}